import { CourseDto } from "@masterschool/course-builder-api"
import { createSlice } from "@reduxjs/toolkit"
import { CourseClient } from "@clients/courseClient"
import { createAppAsyncThunk } from "@app/createAppAsyncThunk"

export interface CourseViewState {
  course: CourseDto | undefined
  // Rejections must be distinguishable from pending, or a bad course id
  // leaves the page on "Loading..." forever.
  loadingState: "idle" | "pending" | "error" | "not-found"
}

const initialState: CourseViewState = {
  course: undefined,
  loadingState: "idle",
}

export const courseViewSlice = createSlice({
  name: "courseView",
  initialState,
  reducers: {
    unmounted: (state) => {
      state.course = undefined
      state.loadingState = "idle"
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCourse.pending, (state, action) => {
        state.course = undefined
        state.loadingState = "pending"
      })
      .addCase(fetchCourse.fulfilled, (state, action) => {
        state.course = action.payload
        state.loadingState = "idle"
      })
      .addCase(fetchCourse.rejected, (state, action) => {
        state.course = undefined
        state.loadingState = action.error.message?.includes("404")
          ? "not-found"
          : "error"
      })
  },
})

export const { unmounted } = courseViewSlice.actions

export const fetchCourse = createAppAsyncThunk(
  "courseView/fetchCourse",
  async (courseMeta: { courseId: string; version: string }) => {
    return CourseClient.getCourseByVersion(
      courseMeta.courseId,
      courseMeta.version,
    )
  },
)

export default courseViewSlice.reducer
